<div class="mt-5 report__page__with__extra__scroll">

    <form #diversificationForm="ngForm" novalidate="novalidate" autocomplete="off">

        <ng-container *ngIf="currentReport?.LATEST?.RISK && currentReport.LATEST.COMPANY.NAICS.R_DV === false && !currentReport?.LATEST?.RISK?.OPT_DV">
            <div class="text-center">
              Diversification Risk was deemed a non-factor for the company based on Industry Type.
              <p>Should you wish to determine Diversification Risk, please click <a role="button" class="color--blue" (click)="currentReport.isLocked ? '' : showHideDiversification()">here</a>.</p>
            </div>
        </ng-container>

        <ng-container *ngIf="currentReport?.LATEST?.RISK && (currentReport.LATEST.COMPANY.NAICS.R_DV || currentReport?.LATEST?.RISK?.OPT_DV)">

            <!-- #region "customers-amount" -->
            <div class="row my-5">
                <div class="col-md-12">
                    <div class="label">How many customers did the Company have in the most recent fiscal year?</div>
                    <div class="row m-0">
                        <div class="col-md-12">
                            <radio-group-button radioGroupButtonId="risk-div-customers-type-radio-group" [selectedOption]="currentReport.LATEST.RISK.DIV_CUSTOMERS"
                                [btnList]="customersCountList" [isButton]="true" id="DIV_CUSTOMERS"
                                [disabled]="currentReport?.isLocked"
                                (optionChange)="currentReport.LATEST.RISK.DIV_CUSTOMERS = $event; callUpdateAPI('DIV_CUSTOMERS')"
                                [(ngModel)]="currentReport.LATEST.RISK.DIV_CUSTOMERS" #DIV_CUSTOMERS="ngModel"
                                name="DIV_CUSTOMERS" required>
                            </radio-group-button>
                        </div>
                    </div>
                </div>
            </div>
            <!-- #endregion -->

            <!-- #region "div15-annual-revenue" -->
            <div class="row my-5" *ngIf="currentReport.LATEST.RISK.DIV_CUSTOMERS">
                <div class="col-md-12">
                    <div class="label">Does any single customer generate more than 15% of the Company’s total annual
                        revenues?</div>

                    <div class="row m-0">
                        <div class="col-md-12">
                            <radio-group-button radioGroupButtonId="single-client-percent-type-radio-group" [selectedOption]="currentReport.LATEST.RISK.DIV_SINGLE_CLIENT_PERCENT"
                                [btnList]="singleClientPerList" [isButton]="true" id="DIV_SINGLE_CLIENT_PERCENT"
                                [disabled]="currentReport?.isLocked"
                                (optionChange)="currentReport.LATEST.RISK.DIV_SINGLE_CLIENT_PERCENT = $event; callUpdateAPI('DIV_SINGLE_CLIENT_PERCENT')"
                                [(ngModel)]="currentReport.LATEST.RISK.DIV_SINGLE_CLIENT_PERCENT"
                                #DIV_SINGLE_CLIENT_PERCENT="ngModel" name="DIV_SINGLE_CLIENT_PERCENT" required>
                            </radio-group-button>
                        </div>
                    </div>

                </div>
            </div>
            <!-- #endregion -->

            <!-- #region "div50-annual-revenue" -->
            <div class="row my-5" *ngIf="currentReport.LATEST.RISK.DIV_CUSTOMERS && currentReport.LATEST.RISK.DIV_SINGLE_CLIENT_PERCENT">

                <div class="col-md-12">

                    <div class="row my-3">
                        <div class="col-md-12">
                            <div class="label">Do any 5 customers generate more than 50% of total annual revenues?</div>

                            <div class="row m-0">
                                <div class="col-md-12">
                                    <radio-group-button radioGroupButtonId="risk-div-more-fifty-type-radio-group" [selectedOption]="currentReport.LATEST.RISK.DIV_MORE_FIFTY"
                                        [btnList]="yesNoList" [isButton]="true" id="DIV_MORE_FIFTY" [disabled]="currentReport?.isLocked"
                                        (optionChange)="currentReport.LATEST.RISK.DIV_MORE_FIFTY = $event; callUpdateAPI('DIV_MORE_FIFTY')"
                                        [(ngModel)]="currentReport.LATEST.RISK.DIV_MORE_FIFTY" #DIV_MORE_FIFTY="ngModel"
                                        name="DIV_MORE_FIFTY" required>
                                    </radio-group-button>
                                </div>
                            </div>

                        </div>
                    </div>

                    <ng-container *ngIf="currentReport.LATEST.RISK.DIV_CUSTOMERS && currentReport.LATEST.RISK.DIV_SINGLE_CLIENT_PERCENT && currentReport.LATEST.RISK.DIV_MORE_FIFTY == 'YES'">

                        <div class="row my-3">
                            <div class="col-md-12">
                                <div class="label">How much of the total annual revenue is generated by the total 5
                                    clients?</div>

                                <div class="row m-0">
                                    <div class="col-md-12">
                                        <radio-group-button [disabled]="currentReport?.isLocked"
                                            radioGroupButtonId="risk-div-sales-percent-type-radio-group"
                                            [selectedOption]="currentReport.LATEST.RISK.DIV_SALES_PERCENT"
                                            [btnList]="salesPercentList" [isButton]="true" id="DIV_SALES_PERCENT"
                                            (optionChange)="currentReport.LATEST.RISK.DIV_SALES_PERCENT = $event; callUpdateAPI('DIV_SALES_PERCENT')"
                                            [(ngModel)]="currentReport.LATEST.RISK.DIV_SALES_PERCENT"
                                            #DIV_SALES_PERCENT="ngModel" name="DIV_SALES_PERCENT" required>
                                        </radio-group-button>
                                    </div>
                                </div>

                            </div>
                        </div>

                        <div class="row my-3" *ngIf="currentReport.LATEST.RISK.DIV_CUSTOMERS && currentReport.LATEST.RISK.DIV_SINGLE_CLIENT_PERCENT && currentReport.LATEST.RISK.DIV_MORE_FIFTY == 'YES' && currentReport.LATEST.RISK.DIV_SALES_PERCENT">
                            <div class="col-md-12">
                                <div class="label">Does the Company have any contracts with these customers that
                                    require
                                    the customer to only purchase these products/services through them?</div>

                                <div class="row m-0">
                                    <div class="col-md-12">
                                        <radio-group-button [disabled]="currentReport?.isLocked"
                                            radioGroupButtonId="risk-div-contracts-type-radio-group"
                                            [selectedOption]="currentReport.LATEST.RISK.DIV_CONTRACTS"
                                            [btnList]="yesNoList" [isButton]="true" id="DIV_CONTRACTS"
                                            (optionChange)="currentReport.LATEST.RISK.DIV_CONTRACTS = $event; callUpdateAPI('DIV_CONTRACTS')"
                                            [(ngModel)]="currentReport.LATEST.RISK.DIV_CONTRACTS"
                                            #DIV_CONTRACTS="ngModel" name="DIV_CONTRACTS" required>
                                        </radio-group-button>
                                    </div>
                                </div>

                            </div>
                        </div>

                        <div class="row my-3" *ngIf="currentReport.LATEST.RISK.DIV_CUSTOMERS && currentReport.LATEST.RISK.DIV_SINGLE_CLIENT_PERCENT && currentReport.LATEST.RISK.DIV_MORE_FIFTY == 'YES' && currentReport.LATEST.RISK.DIV_SALES_PERCENT && currentReport.LATEST.RISK.DIV_CONTRACTS">
                            <div class="col-md-12">
                                <div class="label">If sales were lost from one or many of these customers, could
                                    they easily be replaced
                                    within 12 months?</div>

                                <div class="row m-0">
                                    <div class="col-md-12">
                                        <radio-group-button [disabled]="currentReport?.isLocked"
                                            radioGroupButtonId="risk-div-sales-losttype-radio-group"
                                            [selectedOption]="currentReport.LATEST.RISK.DIV_SALES_LOST"
                                            [btnList]="yesNoList" [isButton]="true" id="DIV_SALES_LOST"
                                            (optionChange)="currentReport.LATEST.RISK.DIV_SALES_LOST = $event; callUpdateAPI('DIV_SALES_LOST')"
                                            [(ngModel)]="currentReport.LATEST.RISK.DIV_SALES_LOST"
                                            #DIV_SALES_LOST="ngModel" name="DIV_SALES_LOST" required>
                                        </radio-group-button>
                                    </div>
                                </div>

                            </div>
                        </div>

                    </ng-container>
                </div>

            </div>
            <!-- #endregion -->

            <!-- #region "notable-supplier" -->
            <div class="row my-5" *ngIf="currentReport.LATEST.RISK.DIV_CUSTOMERS && currentReport.LATEST.RISK.DIV_SINGLE_CLIENT_PERCENT && currentReport.LATEST.RISK.DIV_MORE_FIFTY">

                <div class="col-md-12">
                    <div class="row my-3">
                        <div class="col-md-12">
                            <div class="label">Does the Company have any notable supplier concentration?</div>

                            <div class="row m-0">
                                <div class="col-md-12">
                                    <radio-group-button [disabled]="currentReport?.isLocked"
                                        radioGroupButtonId="risk-div-vendor-percent-type-radio-group"
                                        [selectedOption]="currentReport.LATEST.RISK.DIV_VENDOR_PERCENT"
                                        [btnList]="yesNoList" [isButton]="true" id="DIV_VENDOR_PERCENT"
                                        (optionChange)="currentReport.LATEST.RISK.DIV_VENDOR_PERCENT = $event; callUpdateAPI('DIV_VENDOR_PERCENT')"
                                        [(ngModel)]="currentReport.LATEST.RISK.DIV_VENDOR_PERCENT"
                                        #DIV_VENDOR_PERCENT="ngModel" name="DIV_VENDOR_PERCENT" required>
                                    </radio-group-button>
                                </div>
                            </div>

                        </div>
                    </div>

                    <div class="row my-3" *ngIf="currentReport.LATEST.RISK.DIV_CUSTOMERS && currentReport.LATEST.RISK.DIV_SINGLE_CLIENT_PERCENT && currentReport.LATEST.RISK.DIV_MORE_FIFTY && currentReport.LATEST.RISK.DIV_VENDOR_PERCENT == 'YES'">
                        <div class="col-md-12">
                            <div class="label">Can similar products/services be obtained from others
                                vendor/suppliers?</div>

                            <div class="row m-0">
                                <div class="col-md-12">
                                    <radio-group-button [disabled]="currentReport?.isLocked"
                                        radioGroupButtonId="risk-div-similar-vendor-type-radio-group"
                                        [selectedOption]="currentReport.LATEST.RISK.DIV_SIMILAR_VENDOR"
                                        [btnList]="yesNoList" [isButton]="true" id="DIV_SIMILAR_VENDOR"
                                        (optionChange)="currentReport.LATEST.RISK.DIV_SIMILAR_VENDOR = $event; callUpdateAPI('DIV_SIMILAR_VENDOR')"
                                        [(ngModel)]="currentReport.LATEST.RISK.DIV_SIMILAR_VENDOR"
                                        #DIV_SIMILAR_VENDOR="ngModel" name="DIV_SIMILAR_VENDOR" required>
                                    </radio-group-button>
                                </div>
                            </div>

                        </div>
                    </div>

                </div>

            </div>
            <!-- #endregion -->

        </ng-container>

    </form>

</div>
<report-footer
    [nextBtnEnable]="(currentReport?.LATEST?.RISK && diversificationForm.valid) || currentReport?.isLocked"
    (buttonClicked)="footerButtonClick($event)" [extraBtnText]="'Back to Optional'"
    [extraAvailable]="!currentReport?.isLocked && !currentReport?.LATEST?.COMPANY.NAICS.R_DV && currentReport?.LATEST?.RISK?.OPT_DV"
    [skipAvailable]="!currentReport?.isLocked" [skipArrow]="false" [skipBtnText]="'Reset'"
    [pageId]="reportPageConst.DIVERSIFICATION" [mobileIcon]="'reset-icon'"></report-footer>
